import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../../../adreno-common/src/lib/auth';
import { LookupService } from '../../../../../adreno-common/src/lib/shared';
import { UserContactService } from '../services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-reset-confirmation',
  templateUrl: './reset-avatar-confirmation.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetAvatarConfirmationComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private userContactSvc: UserContactService,
    private lookupSvc: LookupService,
    private authSvc: AuthService
  ) {}

  resetAvatar() {
    this.userContactSvc.resetAvatar();

    this.authSvc.userId$.pipe(take(1)).subscribe((userId) => {
      setTimeout(() => this.lookupSvc.refreshAvatars(userId!), 1000);
    });

    this.activeModal.close();
  }
}
